import { PRIVATE_APP_ROUTE_PATHS } from '@/shared/constants/app-route-paths';
import { pathnameMatchesSomeRoute } from '@/shared/functions/route-path-matches';

export function isTrackablePrivateRoute(pathname: string): boolean {
	return pathnameMatchesSomeRoute(pathname, PRIVATE_APP_ROUTE_PATHS);
}
